import { postApiRequest } from 'api';
import { THandleLessonProps, THandleLessonResponse } from 'types/lesson';

export const handleLesson = (params: THandleLessonProps): Promise<THandleLessonResponse> => {
    return postApiRequest('/lesson/handle/', params);
};
